import { DashboardMetricSet } from '../dashboard-metric';
import { DashboardEventService } from '../dashboard-event.service';
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'app-dashboard-metric-content-pair',
    templateUrl: './dashboard-metric-content-pair.component.html',
    styleUrls: ['./dashboard-metric-content-pair.component.scss', './dashboard-metric.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DashboardMetricContentPairComponent implements OnInit {
    @Input()
    dashboardMetricSet: DashboardMetricSet;

    constructor(private dashboardEventService: DashboardEventService) { }

    ngOnInit() {
    }
}
